import React from 'react'
import './error.scss'

import ErrorIcon from '@mui/icons-material/Error';
import CloseIcon from '@mui/icons-material/Close';

/**
 * Error component for displaying error messages with an optional close button.
 *
 * @component
 * @memberof Components
 * @param {Object} props - The properties passed to the Error component.
 * @param {string} props.error - The error message to display.
 * @param {Function} [props.onClose] - Optional callback function triggered when the close icon is clicked.
 * @param {string} [props.backgroundColor] - Optional background color for the error container.
 * @param {string} [props.textColor] - Optional text color for the error message. Default is `#bb0303`.
 * @param {string} [props.iconColor] - Optional color for the close icon. Default is `#bb0303`.
 *
 * @example
 * <Error error="Something went wrong!" onClose={() => console.log("Closed")} />
 *
 * @returns {JSX.Element} The rendered error message component.
 */
const Error = ({ error, onClose, backgroundColor, textColor, iconColor }) => {
    return (
        <div className='errors' >
            <div className='error-container'>
                <ErrorIcon style={{ color: '#bb0303', marginRight: '1%' }} />
                <p style={{
                    color: textColor || '#bb0303'
                }}>
                    {error}
                </p>
            </div>
            {
                onClose &&
                <CloseIcon onClick={onClose} style={{ color: iconColor || '#bb0303', marginRight: '1%', marginTop: '1%', cursor: 'pointer' }} />
            }
        </div>
    )
}

export default Error